import { EmptyControl, MaxLength, MinLength, Required } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { JsonObject, JsonProperty } from 'json2typescript';
import { EnumGender } from '../../../model/enum-gender';

@JsonObject('KovanHrPerPersonnelModel')
export class PerPersonnelModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

    @EmptyControl()
    @JsonProperty('peopleNum', Number, true)
    peopleNum: number = null;

    @EmptyControl()
    @JsonProperty('id', Number, true)
    id: number = null;

    @EmptyControl()
    @JsonProperty('uuid', String, true)
    uuid: string = null;

    @EmptyControl()
    @JsonProperty('perPeopleStatusId', Number, true)
    perPeopleStatusId: number = null;

    @MaxLength(50)
    @Required()
    @JsonProperty('name', String, true)
    name: string = null;

    @MaxLength(50)
    @Required()
    @JsonProperty('surname', String, true)
    surname: string = null;

    @EmptyControl()
    @JsonProperty('identitySerialNumber', String, true)
    identitySerialNumber: string = null;

    @Required()
    @JsonProperty('identificationNumber', String, true)
    @MaxLength(11)
    @MinLength(11)
    identificationNumber: string = null;

    @Required()
    @JsonProperty('registryNumber', String, true)
    registryNumber: string = null;

    @EmptyControl()
    @JsonProperty('userMessage', String, true)
    userMessage: string = null;

    @EmptyControl()
    @JsonProperty('perPersonnelCadre', String, true)
    perPersonnelCadre: string = null;

    @EmptyControl()
    @JsonProperty('perPersonnelOrganization', String, true)
    perPersonnelOrganization: string = null;

    @EmptyControl()
    @JsonProperty('perPersonnelPosition', String, true)
    perPersonnelPosition: string = null;

    @EmptyControl()
    @JsonProperty('perPersonnelTitle', String, true)
    perPersonnelTitle: string = null;

    @EmptyControl()
    @JsonProperty('perEmployeeTypeId', Number, true)
    perEmployeeTypeId: number = null;

    @EmptyControl()
    @JsonProperty('perEmployeeType', String, true)
    perEmployeeType: string = null;

    @EmptyControl()
    @JsonProperty('perEmployeeTypeCode', String, true)
    perEmployeeTypeCode: string = null;

    @EmptyControl()
    @JsonProperty('perEmployeeSubtypeId', Number, true)
    perEmployeeSubtypeId: number = null;

    @EmptyControl()
    @JsonProperty('perEmployeeSubtype', String, true)
    perEmployeeSubtype: string = null;

    @EmptyControl()
    @JsonProperty('perWorkArea', String, true)
    perWorkArea: string = null;

    @EmptyControl()
    @JsonProperty('perWorkSubarea', String, true)
    perWorkSubarea: string = null;

    @JsonProperty('newPersonnelCreated', Boolean, true)
    newPersonnelCreated: boolean = null;

    @JsonProperty('userInfoMessages', [String], true)
    userInfoMessages: Array<String> = new Array<String>();

    @JsonProperty('userErrorMessages', [String], true)
    userErrorMessages: Array<String> = new Array<String>();

    @EmptyControl()
    @JsonProperty('pictureUuid', String, true)
    pictureUuid: string = null;

    @JsonProperty('existingPassivePersonnel', Boolean, true)
    existingPassivePersonnel: boolean = null;

    @EmptyControl()
    @JsonProperty('existingActivePersonnel', Boolean, true)
    existingActivePersonnel: boolean = null;

    @EmptyControl()
    @JsonProperty('existingActivePersonnelToUpdate', Boolean, true)
    existingActivePersonnelToUpdate: boolean = null;

    @EmptyControl()
    @JsonProperty('newRegistryNumber', Boolean, true)
    newRegistryNumber: boolean = null;

    @EmptyControl()
    @JsonProperty('existingPassivePersonnelToActive', Boolean, true)
    existingPassivePersonnelToActive: boolean = null;

    @EmptyControl()
    @JsonProperty('statusText', String, true)
    statusText: string = null;

    @EmptyControl()
    @JsonProperty('phone', String, true)
    phone: string = null;

    @JsonProperty('phoneCode', String, true)
    phoneCode: string = null;

    @EmptyControl()
    @JsonProperty('email', String, true)
    email: string = null;

    @JsonProperty('employee', Boolean, true)
    employee: boolean = null;

    @EmptyControl()
    @JsonProperty('startDate', HvlDateConverter, true)
    startDate: Date = null;

    @EmptyControl()
    @JsonProperty('active', Boolean, true)
    active: boolean = null;

    @EmptyControl()
    @JsonProperty('personSummaryPrefix', String, true)
    personSummaryPrefix: string = null;

    @EmptyControl()
    @JsonProperty('personSummarySuffix', String, true)
    personSummarySuffix: string = null;

    @EmptyControl()
    @JsonProperty('vestedRightWageDegree', Number, true)
    vestedRightWageDegree: number = null;

    @EmptyControl()
    @JsonProperty('vestedRightWageRank', Number, true)
    vestedRightWageRank: number = null;

    @EmptyControl()
    @JsonProperty('degreeOfCadree', Number, true)
    degreeOfCadree: number = null;

    @EmptyControl()
    @JsonProperty('beingAnOfficerDate', HvlDateConverter, true)
    beingAnOfficerDate: Date = null;

    @EmptyControl()
    @JsonProperty('perOrganizationEndDate', HvlDateConverter, true)
    perOrganizationEndDate: Date = null;

    @JsonProperty('perOrganizationUuid', String, true)
    perOrganizationUuid: string = null;

    @EmptyControl()
    @JsonProperty('perOrganizationBeginDate', HvlDateConverter, true)
    perOrganizationBeginDate: Date = null;

    @JsonProperty('organizationDateInterval', String, true)
    organizationDateInterval: string = null;

    @JsonProperty('serviceClassText', String, true)
    serviceClassText: string = null;

    @JsonProperty('serviceClassId', Number, true)
    serviceClassId: number = null;

    @JsonProperty('perPersonnelOrganizationId', Number, true)
    perPersonnelOrganizationId: number = null;

    @JsonProperty('perPersonnelPositionId', Number, true)
    perPersonnelPositionId: number = null;

    @JsonProperty('perPersonnelTitleId', Number, true)
    perPersonnelTitleId: number = null;

    @JsonProperty('workingDays', Number, true)
    workingDays: number = null;

    @JsonProperty('workingMonths', Number, true)
    workingMonths: number = null;

    @JsonProperty('workingYears', Number, true)
    workingYears: number = null;
    @EmptyControl()
    @JsonProperty('perPersonnelPositionCode', String, true)
    perPersonnelPositionCode: string = null;
    @EmptyControl()
    @JsonProperty('perPersonnelOrganizationCode', String, true)
    perPersonnelOrganizationCode: string = null;

    @JsonProperty('beingAnOfficerYear', Number, true)
    beingAnOfficerYear: number = null;

    @JsonProperty('beingAnOfficerMonth', Number, true)
    beingAnOfficerMonth: number = null;

    @JsonProperty('beingAnOfficerDay', Number, true)
    beingAnOfficerDay: number = null;

    @EmptyControl()
    @JsonProperty('secondmentActive', Boolean, true)
    secondmentActive: boolean = false;

    @EmptyControl()
    @JsonProperty('gender', String, true)
    gender: EnumGender = null;


    get fullName() {
        return `${this.name} ${this.surname}`;
    }

    get personSummaryText() {
        return (this.personSummaryPrefix ?? '') + this.fullName + (this.personSummarySuffix ?? '');
    }

    get compositeKey(){
        return `${this.id}-${this.perOrganizationUuid}`;
    }
}
